module.exports = __webpack_public_path__ + "img/ziliao.3e558f8e.svg";